import { CSSProperties } from 'react';
import { getResizedImage } from 'shared-helpers/common';

import type { Path } from 'shared-types';

interface Props {
  picture: Path['picture'];
  picturePosition: Path['picturePosition'];
  size: number;
  style?: CSSProperties;
}

const PathPicture = ({ picture, picturePosition, size, style }: Props) => {
  return (
    <div
      className="picture"
      style={{
        backgroundImage: `url(${getResizedImage({ url: picture, size })})`,
        backgroundPosition: picturePosition || 'center top',
        ...style
      }}
    >
      <style jsx>{`
        .picture {
          background-size: cover;
          position: relative;
          height: 100%;
          width: 100%;
        }
      `}</style>
    </div>
  );
};

export default PathPicture;
